export default __webpack_public_path__ + "static/media/MOMO.88127b7e.jpg";